import React, { useEffect, useState } from "react";
import "./Campaigns.css";
// import config from "../../config";
// import axios from "axios";

export default function CampaignProductPreview({
  campaignId,
}) {
  const [products, setProducts] =useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!campaignId) return;

    fetchProducts();
  }, [campaignId]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      setError("");

      // TODO
      // const response = await axios.get(
      //   `${config.baseUrl}/admin/campaigns/${campaignId}/products`
      // );
      //
      // setProducts(response.data.content || response.data);

      setProducts([]);
    } catch (err) {
      console.error(err);
      setError("Unable to load campaign products.");
    } finally {
      setLoading(false);
    }
  };

  if (!campaignId) {
    return (
      <div className="empty-state">
        Save the campaign first to preview products.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="loading-state">
        Loading products...
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-state">
        {error}
      </div>
    );
  }

  if (!products.length) {
    return (
      <div className="empty-state">
        No matching products found.
      </div>
    );
  }

  return (
    <div className="campaign-product-preview">

      <h3>
        Matching Products ({products.length})
      </h3>

      <div className="preview-grid">

        {products.map((product) => (

          <div
            key={product.id}
            className="preview-card"
          >

            <img
              src={product.thumbnail}
              alt={product.productName}
              className="preview-image"
            />

            <div className="preview-details">

              <h4>{product.productName}</h4>

              <p>{product.brand}</p>

              <div className="preview-price">

                ₹{product.offerPrice}

                {product.originalPrice && (
                  <span className="original-price">
                    ₹{product.originalPrice}
                  </span>
                )}

              </div>

              {product.discountPercentage && (
                <div className="discount">
                  {product.discountPercentage}% OFF
                </div>
              )}

            </div>

          </div>

        ))}

      </div>

    </div>
  );
}